import { render } from "./TokenApprove.vue?vue&type=template&id=4a51cdb0"
import script from "./TokenApprove.vue?vue&type=script&lang=js"
export * from "./TokenApprove.vue?vue&type=script&lang=js"

import "./TokenApprove.vue?vue&type=style&index=0&id=4a51cdb0&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
